module.exports = __webpack_public_path__ + "static/media/01_central_mobile.605a5a72.jpg";